import * as intro from 'intro.js-react';
const Hints = intro.Hints;
export default Hints;
